import { render, staticRenderFns } from "./Markup.vue?vue&type=template&id=31ea7869&"
import script from "./Markup.vue?vue&type=script&lang=js&"
export * from "./Markup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports